<template>
  <div>
    <!-- 顶部区 -->
    <div class="top">
      <img src="../assets/banner1_m.jpg" />
      <div class="top_title">
        <span>让影片分发快人一步！</span>
      </div>
    </div>

    <div class="content">
      <div class='box'>
        <div class='title'>公司介绍</div>
        <div class='brief_image'>
          <img src="../assets/pic2_m.jpg" />
        </div>
        <div class='brief_content'>
          <div class='brief_container'>
            <div class='brief1'>厦门飞影云科技有限公司是一家</div>
            <div style="text-align: center;">
              <div class='brief2'>引领电影行业科技革新的公司</div>
            </div>
            <div class='brief_brief'>我们正在革新当前电影行业的发行和分发方式。以往，发行公司需要将影片DCP拷贝到移动硬盘，然后通过物流快递寄送到各个影院。</div>
            <div class='brief_brief'>然而，有了飞影云的出现，这一繁琐的分发流程得到了彻底改变。我们引入了先进的网络传输技术，使影片可以通过网络直接传输到各个影院。这一革新使得影片分发到影院的时间大幅缩短，拿到素材当天传输至全国。</div>
            <div class='brief_brief'>飞影云科技的使命是通过技术创新和高效的影片分发服务，为电影行业带来更便捷、快速和可靠的解决方案。我们致力于为电影产业的发展贡献力量，让电影从制片到观影的整个过程更加流畅和高效。</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  
}
</script>

<style lang="scss" scoped>
// 顶部区
.top{
  width: 100%;
  height: 300px;
  position:relative;
  // border-top: 0.1px solid #4761E8;
  img{
    width: 100%;
    height:300px;
  }
  .top_title{
    letter-spacing:2px;
    text-align: center;
    position:absolute;
    color:#FFFFFF;
    top:50px;
    left: 51%;
    transform: translate(-49%,0);// 左右居中
    width:100%;
    font-size:22px;      
  }
}

// 内容
.content{
  background-color: #F8F8F8;
  padding-bottom: 20px;
  // 标题
  .title{
    font-size:18px;
    padding: 25px 0;
    text-align: center;
    color:#333333;
  }
  .brief_image{
    width:100%;
    margin-bottom:-5px;
    img{
      width:100%;
      border-radius:10px 10px 0 0;
    }
  }
  .brief_content{
    width:100%;
    background-color: white;
    border-radius:0 0 10px 10px;
    padding: 20px 0;
    .brief_container{
      width:90%;
      margin:auto;
      .brief1{
        padding: 10px 0 0;
        font-size:16px;
        text-align: center;
        color:#333333;
      }
      .brief2{
        width: 230px;
        display: inline-block;
        background: linear-gradient(to bottom, transparent 50%, #D8E3FF 50%);
        text-align: center;
        color:#333333;
        // margin: 0 0 15px 56px;
      }
      .brief_brief{
        font-size:14px;
        color:#777777;
        line-height:20px;
        text-indent: 28px;
        margin: 10px 0 0;
      }
    }
  }
}
</style>

<style>
.el-divider--horizontal {
  margin: 8px 0;
}
</style>